// extracted by mini-css-extract-plugin
export default {"kycPolicyContainer":"kycPolicy_kycPolicyContainer__oFFHv"};